import { Directive, ElementRef, OnInit, Input } from '@angular/core';

@Directive({
  selector: '[eguardAutofocus]'
})
export class EguardAutofocusDirective implements OnInit {

  private focus: boolean = true;

  @Input()
  set eguardAutofocus(condition: boolean) {
    this.focus = condition !== false;
  }

  constructor(private el: ElementRef) { }

  ngOnInit() {
   if (this.focus) {
     setTimeout(() => {
       this.el.nativeElement.focus();
     })
   }
  }

}



// WEBPACK FOOTER //
// ./src/app/core/directives/eguard-autofocus/eguard-autofocus.directive.ts